export default "__VITE_ASSET__BUJgbzra__"